import axios from "./axios"

class Fidelio {
  async updateRoomStatus(payload) {
    return axios()
      .post("/api/fidelio/room/status", payload)
      .catch(err => _$.error(err))
  }
  async wakeupAnswer(payload) {
    return axios()
      .post("/api/fidelio/wakeup/answer", payload)
      .catch(err => _$.error(err))
  }
}

export default new Fidelio()
